module.exports = __webpack_public_path__ + "assets/projects/digital-data-collection/transition.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/digital-data-collection/transition.mp4
// module id = 42
// module chunks = 0